<template>
  <div class="form-columns">
    <div class="form-side-text">{{$t('signup.forgotPasswordText')}}</div>

    <div class="form-container">
      <div class="header">
        <div class="closeButton">
          <button class="btn theme-close-button" @click="home">
            <font-awesome-icon icon="times" />
          </button>
        </div>
        <h2>{{$t('signin.requestPassword')}}</h2>
      </div>

      <div class="fieldsContainer">
        <div class="input">
            <div style="flex: 1;"><input id="nameField" v-model="usernameInput" v-on:keyup.enter="resetPassword" class="themeInput" type="text" :placeholder="$t('signin.username')" autofocus></div>
            <div><font-awesome-icon icon="user" class="inputImage"/></div>
        </div>        
        
        <div v-if="errorMessage" class="w3-panel errorBox w3-round">{{ errorMessage }} <font-awesome-icon icon="exclamation-circle" class="errorIcon w3-right"/></div>
      </div>

      <div class="buttonContainer">
        <div class="flex"><button class="button-default" @click="resetPassword">{{$t('signin.requestPasswordButton')}}</button></div>
      </div>
    </div>

    <div class="dummy-space"></div>
    <router-link to="/" class="bottomLogo"><img src="../../assets/img/CA_Logo_black.png" alt="Chess Administrator" class="logo-header"> Chess Administrator</router-link>
  </div>  

</template>

<script>
import {RestAPI} from "@aws-amplify/api-rest";
import {user} from "@/components/users";

const apiName = 'api';
const path = '/Authentication/PasswordReset';

export default {
  name: 'ResetPasswordRequest',
  data: function () {
    return {
      usernameInput: "",
      errorMessage: ""
    }
  },
  mounted() {
    this.focusInput();
  },
  computed: {
    username: function () {
      return user.name
    }
  },
  methods: {
    resetPassword() {
      let that = this;
      const myInit = { 
        body: this.usernameInput,
        response: false,
      };
      RestAPI
        .post(apiName, path, myInit)
        .then(response => {
          console.log("Reset succesfully requested." + JSON.stringify(response));
          that.$router.push("/sign-in?ontheside=passwordResetMsgSent");
        })
        .catch(error => {
          that.errorMessage = error.response;
          console.log("Error: " + JSON.stringify(error.response));
        });
    },
    home() {
      this.$router.push('/')
    },
    focusInput() {
      var x = document.getElementById("nameField");
      x.focus();
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
